import { render } from "./AccordsWithTabs.vue?vue&type=template&id=da9654b0"
import script from "./AccordsWithTabs.vue?vue&type=script&lang=js"
export * from "./AccordsWithTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__